// keep up to date with Libraries/Core/Services/FeatureService.cs
export const EMPTY_FEATURE_FLAGS = {
    ALL_CATEGORIES_PARAMETRIC_SEARCH: false,
    API_FEATURE_INVENTORY_MCP: true,
    BOM_EXPORT_LAMBDA: false,
    BOM_V2: false,
    CARBON_FOOTPRINT_API: false,
    CARBON_FOOTPRINT_REQUEST: false,
    CARBON_FOOTPRINT_WIDGET: false,
    CATEGORY_FULLTEXT_SEARCH: false,
    CN_FILEFEED_RESULTS: false,
    DATA_DOME_BOT_HEADERS: false,
    FAQ_STATIC_SITE: false,
    FLEX_PRODUCT_IMAGES: true,
    LEAD_TIME_REPORTING_PUBLIC: false,
    MAPPING_LAST_SEEN: false,
    PART_CHART_FAILED_QUERY_LOGGING: false,
    PART_MODELS_PAGE: false,
    PRODUCT_REDIRECT_ENFORCE_BOM_HASH: false,
    PRODUCT_REDIRECT_ENFORCE_API_HASH: false,
    PRODUCT_SPOTLIGHTS: false,
    RESULTS_BY_PART_DEFAULT: false,
    SEARCH_PROGRESSIVE_DELIVERY: false,
    SMART_SEARCH_INDEX_ENABLED: false,
    SLUICEBOX_INTEGRATION: false,
    SMART_SEARCH_QUERY_PARSING: false,
    SMART_SEARCH: false,
    SNAP_MAGIC_MODELS: false,
    TAILWIND_COMPONENTS_PAGE: false,
    TOTP_REGISTRATION: false,
};

export type FeatureFlags = typeof EMPTY_FEATURE_FLAGS;
